
const Footer = () => {
    return(
        <div><p>By Chris Briant</p></div>
    );
}

export default Footer;